import React from "react";
import { MyModal } from "../../../../components/styled-components";

interface MyModalProps {
  visible: boolean;
  onClose: () => void;
}

const WarningModal: React.FC<MyModalProps> = ({ visible, onClose }) => {
  const message = "กรุณาใส่ข้อมูลให้ถูกต้อง";

  return (
    <MyModal
      title="Warning"
      visible={visible}
      onOk={onClose}
      onCancel={onClose}
      okText="OK"
      cancelText="Cancel"
    >
      <p>{message}</p>
    </MyModal>
  );
};

export default WarningModal;
